import { find } from "~/tools/find";
import { pipe } from "~/tools/pipe";
import { prop } from "~/tools/prop";
import { sortBy } from "~/tools/sort-by";

export interface ChartThresholdStep {
	color: string;
	value: number;
}

export type ChartThresholds = [defaultColor: string, ...steps: ReadonlyArray<ChartThresholdStep>];

export function findChartThresholdColor(value: undefined | number, [defaultColor, ...steps]: ChartThresholds): string {
	if (value == null) {
		return defaultColor;
	}

	const correspondingStep = pipe(
		steps,
		sortBy([prop("value"), "desc"]),
		find((step) => step.value <= value),
	);

	return correspondingStep ? correspondingStep.color : defaultColor;
}
